import {Store} from '@ngrx/store';
import {getDocLinksUrl, State} from '../reducers/index';
import {selectFirstTruthy} from '../util/rx-utils';
import {DocumentsActions} from './documents.action';

export function dispatchFetchDocLinksAction(store: Store<State>) {
  selectFirstTruthy(store, getDocLinksUrl)
  .subscribe(docLinksUrl => store.dispatch(DocumentsActions.fetchDocLinks({url: docLinksUrl})));
}
